export enum SoccerFoulAttribute {
  CausesPenalty = 856,
}
